import { createAction } from '@reduxjs/toolkit';

export const downloadButtonClicked = createAction<
  void,
  'creativeHub/downloader/DOWNLOAD_BUTTON_CLICKED'
>('creativeHub/downloader/DOWNLOAD_BUTTON_CLICKED');
